/**
 * Local Delivery Cart timeslot helpers.
 * Extracted from local-delivery-cart orchestrator.
 */
(function () {
  'use strict';

  function deriveSlotLabel(s) {
    if (s.startHour != null && s.endHour != null) {
      var sh = String(s.startHour).padStart(2, '0');
      var sm = String(s.startMinute || 0).padStart(2, '0');
      var eh = String(s.endHour).padStart(2, '0');
      var em = String(s.endMinute || 0).padStart(2, '0');
      return sh + ':' + sm + ' to ' + eh + ':' + em;
    }
    return s.label || '';
  }

  function emptySelectionSummary() {
    return {
      hadPrevious: false,
      selected: false,
      cleared: false,
      changed: false,
      previous: null,
      next: null,
    };
  }

  function readSelectionMeta(select) {
    if (!select || typeof select.selectedIndex !== 'number' || select.selectedIndex < 0) return null;
    var option = select.options && select.options[select.selectedIndex];
    if (!option || !option.value) return null;
    return {
      value: option.value || '',
      rawLabel: option.getAttribute ? (option.getAttribute('data-raw-label') || option.value || '') : (option.value || ''),
      slotId: option.getAttribute ? (option.getAttribute('data-slot-id') || '') : '',
      tierId: option.getAttribute ? (option.getAttribute('data-tier-id') || '') : '',
      variantId: option.getAttribute ? (option.getAttribute('data-variant-id') || '') : '',
      amount: option.getAttribute ? (option.getAttribute('data-amount') || '') : '',
    };
  }

  function findOptionIndex(select, predicate) {
    if (!select || !select.options || typeof predicate !== 'function') return -1;
    for (var i = 0; i < select.options.length; i++) {
      if (predicate(select.options[i], i)) return i;
    }
    return -1;
  }

  function restoreSelection(select, previousMeta) {
    if (!select || !select.options || !select.options.length) {
      var empty = emptySelectionSummary();
      empty.hadPrevious = !!previousMeta;
      empty.cleared = !!previousMeta;
      empty.previous = previousMeta || null;
      return empty;
    }

    var nextIndex = -1;
    if (previousMeta && previousMeta.slotId) {
      nextIndex = findOptionIndex(select, function (option) {
        return option && option.value && option.getAttribute && option.getAttribute('data-slot-id') === previousMeta.slotId;
      });
    }

    if (nextIndex < 0 && previousMeta && previousMeta.rawLabel) {
      var rawMatches = [];
      for (var i = 0; i < select.options.length; i++) {
        var candidate = select.options[i];
        if (!candidate || !candidate.value || !candidate.getAttribute) continue;
        if ((candidate.getAttribute('data-raw-label') || candidate.value || '') === previousMeta.rawLabel) {
          rawMatches.push(i);
        }
      }
      if (rawMatches.length === 1) {
        nextIndex = rawMatches[0];
      } else if (rawMatches.length > 1 && previousMeta.tierId) {
        for (var j = 0; j < rawMatches.length; j++) {
          var tierCandidate = select.options[rawMatches[j]];
          if (tierCandidate.getAttribute('data-tier-id') === previousMeta.tierId) {
            nextIndex = rawMatches[j];
            break;
          }
        }
      } else if (rawMatches.length > 1 && previousMeta.variantId) {
        for (var k = 0; k < rawMatches.length; k++) {
          var variantCandidate = select.options[rawMatches[k]];
          if (variantCandidate.getAttribute('data-variant-id') === previousMeta.variantId) {
            nextIndex = rawMatches[k];
            break;
          }
        }
      }
    }

    select.selectedIndex = nextIndex >= 0 ? nextIndex : 0;

    var nextMeta = readSelectionMeta(select);
    return {
      hadPrevious: !!previousMeta,
      selected: !!nextMeta,
      cleared: !!previousMeta && !nextMeta,
      changed: !!previousMeta && (
        !nextMeta ||
        previousMeta.slotId !== (nextMeta.slotId || '') ||
        previousMeta.tierId !== (nextMeta.tierId || '') ||
        previousMeta.variantId !== (nextMeta.variantId || '') ||
        previousMeta.amount !== (nextMeta.amount || '')
      ),
      previous: previousMeta || null,
      next: nextMeta,
    };
  }

  function hasSelectableSlotOption(select) {
    if (!select || !select.options) return false;
    for (var i = 0; i < select.options.length; i++) {
      var option = select.options[i];
      if (option && option.value && !option.disabled) return true;
    }
    return false;
  }

  function ensureNoSlotsHint(select, id) {
    if (!id) return null;
    var doc = typeof document !== 'undefined' ? document : null;
    var existing = doc && typeof doc.getElementById === 'function' ? doc.getElementById(id) : null;
    if (existing) return existing;
    if (!doc || typeof doc.createElement !== 'function' || !select || !select.parentNode) return null;

    var hint = doc.createElement('p');
    hint.id = id;
    hint.className = 'wf-ld-hint wf-ld-hint--warn';
    hint.style = hint.style || {};
    hint.style.display = 'none';
    if (typeof hint.setAttribute === 'function') {
      hint.setAttribute('aria-live', 'polite');
      hint.setAttribute('aria-hidden', 'true');
    }
    if (select.nextSibling && typeof select.parentNode.insertBefore === 'function') {
      select.parentNode.insertBefore(hint, select.nextSibling);
    } else if (typeof select.parentNode.appendChild === 'function') {
      select.parentNode.appendChild(hint);
    }
    return hint;
  }

  function getNoSlotsHint(opts, id, select) {
    if (opts && typeof opts.getNoSlotsHint === 'function') {
      var fromOpts = opts.getNoSlotsHint(id, select);
      if (fromOpts) return fromOpts;
    }
    return ensureNoSlotsHint(select, id);
  }

  function updateNoSlotsHint(opts, select, id, message, shouldShow) {
    var hint = getNoSlotsHint(opts, id, select);
    if (!hint) return;
    hint.textContent = shouldShow ? message : '';
    hint.style = hint.style || {};
    hint.style.display = shouldShow ? 'block' : 'none';
    if (typeof hint.setAttribute === 'function') {
      hint.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }
  }

  function createTimeslotController(opts) {
    opts = opts || {};
    var latestAvailabilityRequestToken = 0;

    function getConfig() {
      return typeof opts.getConfig === 'function' ? opts.getConfig() : null;
    }

    function populateTimeslots(dateOverride) {
      var config = getConfig();
      if (!config) {
        return {
          standard: emptySelectionSummary(),
          express: emptySelectionSummary(),
        };
      }

      var dateVal =
        dateOverride ||
        (typeof opts.getDateValue === 'function' ? opts.getDateValue() : '');

      var stdSelect = typeof opts.getStandardSelect === 'function' ? opts.getStandardSelect() : null;
      var expSelect = typeof opts.getExpressSelect === 'function' ? opts.getExpressSelect() : null;
      var prevStdMeta = readSelectionMeta(stdSelect);
      var prevExpMeta = readSelectionMeta(expSelect);
      var isCollection = !!(typeof opts.getMethodCollectionChecked === 'function' && opts.getMethodCollectionChecked());
      var mode = isCollection ? 'collection' : 'delivery';
      var overrides = config.override_days || [];
      var availabilityData = typeof opts.getAvailabilityData === 'function' ? opts.getAvailabilityData() : null;
      var standardSummary = emptySelectionSummary();
      var expressSummary = emptySelectionSummary();

      if (stdSelect) {
        var slots = isCollection ? (config.collection_timeslots || []) : config.timeslots;
        var available = opts.SLOT.filterAvailableSlots(
          slots,
          dateVal,
          config.blackout_dates,
          opts.isPastCutoff,
          overrides,
          mode,
        );
        stdSelect.innerHTML = '<option value="">Select timeslot</option>';
        available.forEach(function (s) {
          var lbl = deriveSlotLabel(s);
          if (!lbl) return;
          var deliveryPricingMeta = !isCollection && s.id
            ? opts.getStandardSlotPricingMeta(String(s.id), s)
            : { tierId: '', variantId: '', amount: null, hasTierRule: false };
          var amountLabel = deliveryPricingMeta.amount != null ? opts.formatExpressAmount(deliveryPricingMeta.amount) : null;
          var availabilitySlots = isCollection
            ? (availabilityData && availabilityData.collectionSlots)
            : (availabilityData && availabilityData.slots);
          var avail = availabilitySlots
            ? availabilitySlots.find(function (a) { return a.slotId === s.id; })
            : null;
          if (avail && avail.visible === false) return;
          var opt = document.createElement('option');
          opt.value = lbl;
          opt.setAttribute('data-raw-label', lbl);
          opt.textContent = amountLabel ? (lbl + ' (+$' + amountLabel + ')') : lbl;
          if (s.id) opt.setAttribute('data-slot-id', String(s.id));
          if (s.sourceSlotId) opt.setAttribute('data-source-slot-id', String(s.sourceSlotId));
          if (deliveryPricingMeta.tierId) opt.setAttribute('data-tier-id', deliveryPricingMeta.tierId);
          if (deliveryPricingMeta.variantId) opt.setAttribute('data-variant-id', deliveryPricingMeta.variantId);
          if (deliveryPricingMeta.amount != null) opt.setAttribute('data-amount', String(deliveryPricingMeta.amount));
          opt.setAttribute('data-fee-label', deliveryPricingMeta.feeLabel || 'Delivery Fee');
          if (!isCollection && deliveryPricingMeta.hasTierRule && !deliveryPricingMeta.variantId) {
            opt.disabled = true;
            opt.textContent = amountLabel
              ? lbl + ' (+$' + amountLabel + ') (Unavailable)'
              : lbl + ' (Unavailable)';
          }
          if (avail && !avail.available) {
            opt.disabled = true;
            opt.textContent = amountLabel
              ? lbl + ' (+$' + amountLabel + ') (Full)'
              : lbl + ' (Full)';
          }
          stdSelect.appendChild(opt);
        });
        standardSummary = restoreSelection(stdSelect, prevStdMeta);
        updateNoSlotsHint(
          opts,
          stdSelect,
          'wf-ld-timeslot-empty-hint',
          isCollection ? 'No collection timeslots available for this date.' : 'No delivery timeslots available for this date.',
          !!dateVal && !hasSelectableSlotOption(stdSelect)
        );
      }

      if (expSelect) {
        expSelect.innerHTML = '<option value="">Select express timeslot</option>';
        var expressEnabled = !isCollection && config.express_timeslots && config.express_timeslots.length > 0;
        if (expressEnabled) {
          var expressSlots = opts.SLOT.filterAvailableSlots(
            config.express_timeslots,
            dateVal,
            config.blackout_dates,
            opts.isPastCutoff,
            overrides,
            'express',
          );
          expressSlots.forEach(function (s) {
            var lbl = deriveSlotLabel(s);
            if (!lbl) return;
            var pricingMeta = opts.getExpressSlotPricingMeta(String(s.id || ''), s);
            var amountLabel = pricingMeta.amount != null ? opts.formatExpressAmount(pricingMeta.amount) : null;
            var avail = availabilityData && availabilityData.expressSlots
              ? availabilityData.expressSlots.find(function (a) { return a.slotId === s.id; })
              : null;
            if (avail && avail.visible === false) return;
            var opt = document.createElement('option');
            opt.value = lbl;
            opt.setAttribute('data-raw-label', lbl);
            if (s.id) opt.setAttribute('data-slot-id', String(s.id));
            if (s.sourceSlotId) opt.setAttribute('data-source-slot-id', String(s.sourceSlotId));
            if (pricingMeta.tierId) opt.setAttribute('data-tier-id', pricingMeta.tierId);
            if (pricingMeta.variantId) opt.setAttribute('data-variant-id', pricingMeta.variantId);
            if (pricingMeta.amount != null) opt.setAttribute('data-amount', String(pricingMeta.amount));
            opt.textContent = amountLabel ? lbl + ' (+$' + amountLabel + ')' : lbl;
            if (!pricingMeta.variantId) {
              opt.disabled = true;
              opt.textContent = amountLabel
                ? lbl + ' (+$' + amountLabel + ') (Unavailable)'
                : lbl + ' (Unavailable)';
            }
            if (avail && !avail.available) {
              opt.disabled = true;
              opt.textContent = amountLabel
                ? lbl + ' (+$' + amountLabel + ') (Full)'
                : lbl + ' (Full)';
            }
            expSelect.appendChild(opt);
          });
        }
        expressSummary = restoreSelection(expSelect, prevExpMeta);
        updateNoSlotsHint(
          opts,
          expSelect,
          'wf-ld-express-timeslot-empty-hint',
          'No express timeslots available for this date.',
          !!dateVal && expressEnabled && !hasSelectableSlotOption(expSelect)
        );
        if (typeof opts.updateExpressCardLabel === 'function') opts.updateExpressCardLabel();
      }

      if (typeof opts.updateStandardCardLabel === 'function') opts.updateStandardCardLabel();
      return {
        standard: standardSummary,
        express: expressSummary,
      };
    }

    function fetchAvailabilityAndPopulate(dateVal) {
      var token = ++latestAvailabilityRequestToken;
      if (typeof opts.setAvailabilityData === 'function') opts.setAvailabilityData(null);
      var initialSummary = populateTimeslots(dateVal);
      return Promise.resolve(opts.fetchAvailability(dateVal)).then(function (data) {
        if (token !== latestAvailabilityRequestToken) return initialSummary;
        if (!data) return initialSummary;
        if (typeof opts.setAvailabilityData === 'function') opts.setAvailabilityData(data);
        return populateTimeslots(dateVal);
      }).catch(function () {
        return initialSummary;
      });
    }

    function resetAvailability() {
      latestAvailabilityRequestToken += 1;
      if (typeof opts.setAvailabilityData === 'function') opts.setAvailabilityData(null);
    }

    return {
      deriveSlotLabel: deriveSlotLabel,
      populateTimeslots: populateTimeslots,
      fetchAvailabilityAndPopulate: fetchAvailabilityAndPopulate,
      resetAvailability: resetAvailability,
      getRequestToken: function () { return latestAvailabilityRequestToken; },
    };
  }

  window.WF_LD_CART_TIMESLOTS = {
    deriveSlotLabel: deriveSlotLabel,
    createTimeslotController: createTimeslotController,
  };
})();
